(() => {
  const root = document.querySelector('[data-language-welcome]');
  if (!root) return;

  const storageKey = 'malvros-language-choice';
  const cookieKey = 'malvros_language_choice';
  const forcePreview = new URLSearchParams(window.location.search).get('choose-language') === '1';
  const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
  let previouslyFocused = null;

  const readChoice = () => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (stored) return stored;
    } catch (error) {
      // Fall back to the first-party cookie when browser storage is unavailable.
    }

    const cookie = document.cookie
      .split('; ')
      .find((entry) => entry.startsWith(`${cookieKey}=`));
    if (!cookie) return '';

    try {
      return decodeURIComponent(cookie.split('=').slice(1).join('='));
    } catch (error) {
      return '';
    }
  };

  const rememberChoice = (locale) => {
    try {
      window.localStorage.setItem(storageKey, locale);
    } catch (error) {
      // The cookie below still prevents the chooser from repeating unnecessarily.
    }

    document.cookie = `${cookieKey}=${encodeURIComponent(locale)}; Max-Age=31536000; Path=/; SameSite=Lax`;
  };

  const focusableChoices = () => Array.from(root.querySelectorAll('[data-language-choice]'));

  const open = () => {
    previouslyFocused = document.activeElement;
    root.hidden = false;
    document.body.classList.add('malvros-language-welcome-open');
    window.requestAnimationFrame(() => {
      root.classList.add('is-open');
      const current = root.querySelector('[data-language-choice][aria-current="true"]');
      (current || focusableChoices()[0] || root.querySelector('[role="dialog"]'))?.focus();
    });
  };

  const close = () => {
    root.classList.remove('is-open');
    document.body.classList.remove('malvros-language-welcome-open');
    window.setTimeout(() => {
      root.hidden = true;
      previouslyFocused?.focus?.();
    }, 180);
  };

  root.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-language-choice]');
    if (!choice) return;

    const locale = choice.dataset.languageChoice;
    const input = root.querySelector('[data-language-welcome-input]');
    const form = choice.closest('form');
    if (!locale || !input || !form) return;

    rememberChoice(locale);
    input.value = locale;

    if (locale === root.dataset.currentLanguage) {
      close();
      return;
    }

    root.classList.add('is-leaving');
    root.setAttribute('aria-busy', 'true');
    form.submit();
  });

  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;

    const choices = focusableChoices();
    if (!choices.length) return;
    const first = choices[0];
    const last = choices[choices.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (forcePreview || (!isThemeEditor && !readChoice())) open();
})();
